import { content } from "../data/siteData";

export const siteUrl = "https://alexandrefernandes.dev";
export const siteName = "Alexandre Fernandes";

const personId = `${siteUrl}/#person`;
const ogLocales = { en: "en_US", de: "de_DE" };

// "/" and "/projects/x" for English, "/de" and "/de/projects/x" for German.
export const localePath = (locale, path = "") =>
  locale === "de" ? `/de${path}` : path || "/";

export const rootMetadata = {
  metadataBase: new URL(siteUrl),
  title: {
    default: content.en.meta.title,
    template: `%s — ${siteName}`,
  },
  authors: [{ name: siteName, url: siteUrl }],
  robots: { index: true, follow: true },
  icons: {
    icon: "/favicon.svg",
    apple: "/apple-touch-icon.svg",
  },
};

export const rootViewport = { themeColor: "#333333" };

export function pageMetadata({ locale, path = "", title, description, absoluteTitle = false }) {
  const otherLocale = locale === "en" ? "de" : "en";
  return {
    title: absoluteTitle ? { absolute: title } : title,
    description,
    alternates: {
      canonical: localePath(locale, path),
      languages: {
        en: localePath("en", path),
        de: localePath("de", path),
        "x-default": localePath("en", path),
      },
    },
    openGraph: {
      type: "website",
      url: localePath(locale, path),
      title,
      description,
      siteName,
      locale: ogLocales[locale],
      alternateLocale: [ogLocales[otherLocale]],
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
    },
  };
}

export function personJsonLd(locale) {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": personId,
    name: siteName,
    url: siteUrl,
    jobTitle: "Software Engineer (AI/ML)",
    description: content[locale].meta.description,
    address: {
      "@type": "PostalAddress",
      addressLocality: "Schleswig",
      addressRegion: "Schleswig-Holstein",
      addressCountry: "DE",
    },
    sameAs: [
      "https://github.com/AlexPT2k22",
      "https://www.linkedin.com/in/alexandrerodrifernandes/",
    ],
    knowsLanguage: ["pt", "en", "de"],
    knowsAbout: [
      "Artificial Intelligence",
      "Machine Learning",
      "Large Language Models",
      "Retrieval-Augmented Generation",
      "Text-to-SQL",
      "LLM Evaluation",
      "Computer Vision",
      "Python",
      "PyTorch",
      "FastAPI",
      "LangChain",
      "LangGraph",
      "React",
      "Node.js",
      "PostgreSQL",
      "Full Stack Development",
    ],
    alumniOf: {
      "@type": "CollegeOrUniversity",
      name: "Instituto Politécnico de Viseu",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Viseu",
        addressCountry: "PT",
      },
    },
  };
}

export function projectJsonLd(project, locale) {
  const t = content[locale].projectPage;
  const p = project[locale];
  const url = `${siteUrl}${localePath(locale, `/projects/${project.slug}`)}`;
  const home = `${siteUrl}${localePath(locale)}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "SoftwareSourceCode",
        name: p.title,
        description: p.description,
        url,
        inLanguage: locale,
        codeRepository: project.repo,
        keywords: project.tech.join(", "),
        author: { "@id": personId },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: t.breadcrumbHome, item: home },
          { "@type": "ListItem", position: 2, name: p.title, item: url },
        ],
      },
    ],
  };
}
